import {GbpConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/gbpconfiguration';
import {GbpLinkedAccount} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/gbp/gbplinkedaccount';
import {EnterpriseConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/enterpriseconfiguration';
import {Task} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/task';
import {TaskIds} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/taskids';

import BookSvg from '/src/com/yext/listingslaunchstorm/public/icons/book.svg';
import GoogleBusinessProfileLogoLargeSvg from '/src/com/yext/listingslaunchstorm/public/icons/google-business-profile-logo-large.svg';
import GoogleBusinessProfileLogoSvg from '/src/com/yext/listingslaunchstorm/public/icons/google-business-profile-logo.svg';

export const GbpLinkedAccountTask = new Task({
  id: TaskIds.GBP_LINKED_ACCOUNT,

  getCard: (_enterpriseConfiguration, _index, selectedPageId, setSelectedPageId, disabled) => ({
    id: TaskIds.GBP_LINKED_ACCOUNT,
    title: yext.msg('Linked Accounts'),
    icon: <GoogleBusinessProfileLogoSvg />,
    isSelected: TaskIds.GBP_LINKED_ACCOUNT === selectedPageId,
    onClick: disabled ? undefined : () => setSelectedPageId(TaskIds.GBP_LINKED_ACCOUNT),
    content: undefined,
  }),

  getPage: (enterpriseConfiguration, setEnterpriseConfiguration, pageControls) => ({
    id: TaskIds.GBP_LINKED_ACCOUNT,
    layoutHeader: {
      icon: <GoogleBusinessProfileLogoLargeSvg />,
      title: yext.msg('Google Business Profile'),
      description: yext.msg('Link your Google Business Profile account. Linking your account allows you to manage your Google Business Profile listings through this platform. Your account will stay linked and can be found in Account Settings.'),
      resourceLink: {
        src: 'https://hitchhikers.yext.com/tracks/listings/lis310-google-my-business/',
        external: true,
        displayText: yext.msg('Learn About the Google Business Profile Integration'),
        icon: <BookSvg />,
      },
    },
    content: <GbpLinkedAccount
      gbpConfiguration={enterpriseConfiguration.gbpConfiguration ?? GbpConfiguration.empty()}
      setGbpConfiguration={gbpConfiguration => setEnterpriseConfiguration(
        new EnterpriseConfiguration({...enterpriseConfiguration, gbpConfiguration}),
      )}
    />,
  }),

  isComplete: enterpriseConfiguration =>  isConfigurationComplete(enterpriseConfiguration?.gbpConfiguration),
  isSectionSkipped: enterpriseConfiguration => enterpriseConfiguration?.gbpConfiguration?.skipSetup === true
});

/**
 * @param {GbpConfiguration | undefined} gbpConfiguration
 * @returns {boolean}
 */
function isConfigurationComplete(gbpConfiguration) {
  return !!(gbpConfiguration?.linkedAccount && gbpConfiguration?.groupId);
}
